import styled from "styled-components";
import { FieldGrid, WideField } from "../../styles";

export const GenralDataContainer = styled(FieldGrid)``;

export const ReportNameArea = styled(WideField)``;
